const styles = () => ({
  root: {
    width: '100%',
    height: '100%',
  },

  searchQueryField: {
    width: 230,
    marginRight: 20,
  },

  filter: {
    alignItems: 'center',
    background: '#fafbfc',
    borderBottom: '1px solid #e1e9f0',
    display: 'flex',
    padding: '24px 40px',
  },

  filterCount: {
    color: '#596168',
    fontSize: 14,
    fontWeight: 400,
    margin: 0,

    '& strong': {
      fontWeight: 500,
    },
  },

  filterSearch: {
    margin: '0 8px 0 auto',
    width: 300,
  },

  formPage: {
    padding: '0 32px',
  },

  tabContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
  },
});

export default styles;
